import React, { useState } from "react";
import {
  Box,
  Image,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Tag,
  HStack,
} from "@chakra-ui/react";

const ModalContainer = ({
  isOpen,
  onClose,
  item,
  title,
  imageUrl,
  description,
  tools,
  link,
  buttonText,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="#530054">{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Image
            src={imageUrl}
            alt={title}
            borderRadius="10px"
            mb={2}
            w="100%"
            h="auto"
          />
          <Text mb={4} color="#000" fontSize="lg">
            {description}
          </Text>
          {tools && (
            <Box mb={4}>
              <Text fontWeight="bold" color="#000">
                Tools Used:
              </Text>
              <HStack spacing={2} mt={2}>
                {tools.map((tool, index) => (
                  <Tag key={index} colorScheme="purple">
                    {tool}
                  </Tag>
                ))}
              </HStack>
            </Box>
          )}
          <Text textAlign="center">{title}</Text>
        </ModalBody>
        <ModalFooter>
          {link && (
            <Button
              colorScheme="purple"
              mr={3}
              as="a"
              href={link}
              target="_blank"
              width="100%"
            >
              {buttonText}
            </Button>
          )}
          {/* <Button colorScheme="blue" mr={3} onClick={onClose}>
            Close
          </Button> */}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalContainer;
